import axios from "axios"
import { REACT_APP_API } from '../../config'

const FILES_ROOT = '/files'

/**
 * Elimina todos los File_association asociados al id recibido
 * @param {Array<String>} fileIds Arreglo de Ids de los archivos
 * @param {String} associationId Id de las asociaciones a eliminar
 * @param {String} associationId Id de las asociaciones a eliminar
 */
export const deleteFileAssociationsByEntity = async (fileIds, associationId, entityName) => {
    const body = {files: fileIds}
    const response = await axios.put(REACT_APP_API + `${FILES_ROOT}/associations/bulkDelete/${entityName}/${associationId}`, body);

    return response.data;
}
